import {
  all,
  call,
  put,
  takeEvery,
  takeLatest,
  select,
} from 'redux-saga/effects';
import { fetchMethodByScope } from '../../../common/constants/EntityActions';
import envConfig from '../../../config';
import {
  organizationFetchData,
  organizationFetchStatbarData,
  fetchOrganizationDataById,
  organizationArchive,
  createOrganization,
  editOrganization,
  updateTableColumnDefinition,
  updateOrganizationField,
  fetchContactDataByOrganizationId,
  fetchPipelineDataById,
  // contactFetchData,
  organizationRestore,
  organizationChurn,
  resetOrganizationListData,
  fetchAccountDataById,
  fetchContactDataById,
  getPartialInitialOrganizationList,
} from '../../routines';
import { request } from '../../../common/util/RestClient';
import SUCCESS_MESSAGES from '../../../common/constants/SuccessMessagesConstants';
import organizationsApi from '../../../api/organizations';
import { mergeMultipleResponses } from '../../../common/util/EntityUtils';
import {
  ACCOUNT_360,
  CONTACT_360,
  ORGANIZATION_360,
  PIPELINE_360,
} from '../../../common/constants/EntityScopeConstants';
import { DATE_FORMAT } from '../../../common/constants/DateTimeConstants';
import { GTM_TRACK_EVENT } from '../../../common/GoogleTagManager/GoogleTagManager';
import { GTM_EVENTS } from '../../../common/GoogleTagManager/GTMEventConstants';
import { clearLinkedEntities } from '../../routines/linkedEntityRoutine';

export function* archiveOrganizationSaga({ payload }) {
  try {
    const { organizationId, scope, accountId, contactId, pipelineId } = payload;
    const URL = `${envConfig.APIG_URL}core/organizations/${organizationId}/archive`;
    yield call(request, URL, {
      method: 'PUT',
      payload: {},
    });
    GTM_TRACK_EVENT(GTM_EVENTS.ACTIONS_ORGANIZATION_ARCHIVED);
    yield put(
      organizationArchive.success({
        organizationId,
        successMessage: SUCCESS_MESSAGES.ARCHIVE_ORGANIZATION,
      })
    );
    if (scope && scope === ACCOUNT_360) {
      yield put(fetchAccountDataById.trigger({ accountId }));
    } else if (scope && scope === CONTACT_360) {
      yield put(fetchContactDataById.trigger({ contactId }));
    } else if (scope && scope === ORGANIZATION_360) {
      yield put(fetchOrganizationDataById.trigger({ organizationId }));
    } else if (scope && scope === PIPELINE_360) {
      yield put(fetchPipelineDataById.trigger({ pipelineId }));
    }
    yield put(
      organizationFetchData.trigger({
        usePrevPayload: true,
        preservePreviousList: true,
        isAfterAction: true,
      })
    );
    yield put(getPartialInitialOrganizationList.trigger());
  } catch (err) {
    yield put(organizationArchive.failure({ error: err }));
  }
}

export function* restoreOrganizationSaga({ payload }) {
  try {
    const { organizationId, scope, accountId, contactId, pipelineId } = payload;
    const URL = `${envConfig.APIG_URL}core/organizations/${organizationId}/restore`;
    yield call(request, URL, {
      method: 'PUT',
      payload: {},
    });
    GTM_TRACK_EVENT(GTM_EVENTS.ACTIONS_ORGANIZATION_UNARCHIVED);
    yield put(
      organizationRestore.success({
        organizationId,
        successMessage: SUCCESS_MESSAGES.RESTORE_ORGANIZATION,
      })
    );
    if (scope && scope === ACCOUNT_360) {
      yield put(fetchAccountDataById.trigger({ accountId }));
    } else if (scope && scope === CONTACT_360) {
      yield put(fetchContactDataById.trigger({ contactId }));
    } else if (scope && scope === ORGANIZATION_360) {
      yield put(fetchOrganizationDataById.trigger({ organizationId }));
    } else if (scope && scope === PIPELINE_360) {
      yield put(fetchPipelineDataById.trigger({ pipelineId }));
    }
    yield put(
      organizationFetchData.trigger({
        usePrevPayload: true,
        preservePreviousList: true,
        isAfterAction: true,
      })
    );
    yield put(getPartialInitialOrganizationList.trigger());
  } catch (err) {
    yield put(organizationRestore.failure({ error: err }));
  }
}

export function* churnOrganizationSaga({ payload }) {
  try {
    const {
      organizationId,
      churn,
      scope,
      accountId,
      contactId,
      date,
      reason,
      comments,
      pipelineId,
    } = payload;
    const URL = `${envConfig.APIG_URL}core/organizations/${organizationId}/churn-status`;
    yield call(request, URL, {
      method: 'PUT',
      payload: {
        churn,
        ...(date && { date: date.format(DATE_FORMAT.defaultDateFormat1) }),
        ...(reason && { reason }),
        ...(comments && { comments }),
      },
    });
    GTM_TRACK_EVENT(GTM_EVENTS.ACTIONS_ORGANIZATION_CHURN);
    yield put(
      organizationChurn.success({
        organizationId,
        successMessage: SUCCESS_MESSAGES.CHURN_ORGANIZATION,
      })
    );
    if (scope && scope === ACCOUNT_360) {
      yield put(fetchAccountDataById.trigger({ accountId }));
    } else if (scope && scope === CONTACT_360) {
      yield put(fetchContactDataById.trigger({ contactId }));
    } else if (scope && scope === ORGANIZATION_360) {
      yield put(fetchOrganizationDataById.trigger({ organizationId }));
    } else if (scope && scope === PIPELINE_360) {
      yield put(fetchPipelineDataById.trigger({ pipelineId }));
    }
    yield put(
      organizationFetchData.trigger({
        usePrevPayload: true,
        preservePreviousList: true,
        isAfterAction: true,
      })
    );
    yield put(getPartialInitialOrganizationList.trigger());
  } catch (err) {
    yield put(organizationChurn.failure({ error: err }));
  }
}
export function* organizationFetchStatbarDataSaga({ payload }) {
  try {
    const { payload: payloadToUse, displayCurrency } = payload;
    const response = yield call(
      organizationsApi.getOrganizationsStatBar,
      displayCurrency,
      payloadToUse
    );
    yield put(
      organizationFetchStatbarData.success({
        ...response,
      })
    );
  } catch (err) {
    yield put(organizationFetchStatbarData.failure({ error: err }));
  } finally {
    yield put(organizationFetchStatbarData.fulfill());
  }
}
export function* fetchOrganizationsSaga({ payload }) {
  try {
    const displayCurrency = yield select(
      (state) => state.currentUser.user.displayCurrency
    );
    const { currentPayload: prevPayload, myEntitiesOnly } = yield select(
      (state) => state.organizations
    );

    let payloadToUse;

    if (payload && payload.usePrevPayload) {
      payloadToUse = { ...prevPayload, myEntitiesOnly };
    } else {
      payloadToUse = { ...payload, myEntitiesOnly };
    }
    if (payload && payload.entityIds) {
      // always override
      payloadToUse = payloadToUse
        ? { ...payloadToUse, entityIds: payload.entityIds }
        : { entityIds: payload.entityIds };
    }
    if (payload && payload.forcePage) {
      // always override
      payloadToUse = payloadToUse
        ? { ...payloadToUse, page: payload.forcePage }
        : { page: payload.forcePage };
    }

    if (payloadToUse?.entityIds) {
      yield put(resetOrganizationListData());
    }
    if (
      payloadToUse.isBoard &&
      payload?.preservePreviousList &&
      payload?.isAfterAction
    ) {
      const currentPage = payloadToUse.page || 1;
      let current = 0;
      const pendingResponses = [];
      do {
        const pageResponse = call(
          organizationsApi.getOrganizations,
          displayCurrency,
          { ...payloadToUse, page: current + 1 }
        );
        pendingResponses.push(pageResponse);
        current += 1;
      } while (current < currentPage);

      const responses = yield all(pendingResponses);
      yield put(
        organizationFetchStatbarData.trigger({
          payload: payloadToUse,
          displayCurrency,
        })
      );
      const response = mergeMultipleResponses(responses);

      yield put(
        organizationFetchData.success({
          ...response,
          preservePreviousList: false,
          currentPayload: payloadToUse,
        })
      );
      return;
      // warning for future: this method exits from here and does not exe anything below
    }
    // const response = yield;

    const [response] = yield all([
      call(organizationsApi.getOrganizations, displayCurrency, payloadToUse),
      put(
        organizationFetchStatbarData.trigger({
          payload: payloadToUse,
          displayCurrency,
        })
      ),
    ]);
    yield put(
      organizationFetchData.success({
        ...response,
        preservePreviousList:
          payloadToUse.isBoard && payload?.preservePreviousList,
        currentPayload: payloadToUse,
      })
    );
  } catch (err) {
    yield put(organizationFetchData.failure({ error: err }));
  } finally {
    yield put(organizationFetchData.fulfill());
  }
}

export function* fetchOrganizationByIdSaga({ payload }) {
  try {
    const { organizationId } = payload;
    const displayCurrency = yield select(
      (state) => state.currentUser.user.displayCurrency
    );
    const URL = `${envConfig.APIG_URL}core/organizations/${organizationId}?displayCurrency=${displayCurrency}`;
    const response = yield call(request, URL);
    yield put(fetchOrganizationDataById.success(response));
  } catch (err) {
    yield put(fetchOrganizationDataById.failure({ error: err }));
  } finally {
    yield put(fetchOrganizationDataById.fulfill());
  }
}

export function* createOrganizationSaga({ payload }) {
  try {
    const { scopeData, ...formData } = payload;
    const URL = `${envConfig.APIG_URL}core/organizations`;
    const config = {
      method: 'POST',
      payload: formData,
    };
    GTM_TRACK_EVENT(GTM_EVENTS.ACTIONS_ORGANIZATION_CREATED);
    const response = yield call(request, URL, config);
    yield put(
      createOrganization.success({
        response,
        successMessage: SUCCESS_MESSAGES.ADD_ORGANIZATION,
      })
    );
    yield put(
      organizationFetchData.trigger({
        usePrevPayload: true,
        preservePreviousList: true,
        isAfterAction: true,
      })
    );
    yield put(getPartialInitialOrganizationList.trigger());
    if (scopeData) {
      const { scope, ...entityId } = scopeData;
      yield put(fetchMethodByScope[scope].trigger({ ...entityId }));
    }
    // if (formData.contacts) {
    //   yield put(contactFetchData.trigger());
    // }
  } catch (err) {
    yield put(createOrganization.failure({ error: err }));
  } finally {
    yield put(createOrganization.fulfill());
  }
}
export function* editOrganizationSaga({ payload }) {
  try {
    const { formData, id, scopeData } = payload;
    const URL = `${envConfig.APIG_URL}core/organizations/${id}`;
    delete formData.organizationId;
    const config = {
      method: 'POST',
      payload: formData,
    };
    GTM_TRACK_EVENT(GTM_EVENTS.ACTIONS_ORGANIZATION_UPDATED);
    const response = yield call(request, URL, config);
    yield put(
      editOrganization.success({
        response,
        successMessage: SUCCESS_MESSAGES.EDIT_ORGANIZATION,
      })
    );
    yield put(
      organizationFetchData.trigger({
        usePrevPayload: true,
        preservePreviousList: true,
        isAfterAction: true,
      })
    );
    yield put(getPartialInitialOrganizationList.trigger());
    if (scopeData) {
      const { scope, ...entityId } = scopeData;
      yield put(fetchMethodByScope[scope].trigger({ ...entityId }));
    }
    // if (formData.contacts) {
    //   yield put(contactFetchData.trigger());
    // }
    yield put(clearLinkedEntities.trigger());
  } catch (err) {
    yield put(editOrganization.failure({ error: err }));
  }
}

export function* updateOrganizationFieldSaga({ payload }) {
  try {
    const { scope, id, formData } = payload;
    const definition = Object.keys(formData.data)[0];
    yield put(
      updateTableColumnDefinition.trigger({
        scope,
        definition,
        data: { isValueUpdating: true },
      })
    );
    const URL = `${envConfig.APIG_URL}core/organizations/${id}`;
    const config = {
      method: 'POST',
      payload: formData,
    };
    yield call(request, URL, config);
    yield put(
      updateTableColumnDefinition.trigger({
        scope,
        definition,
        data: { isValueUpdating: false, isEditMode: false },
      })
    );
    yield put(
      updateOrganizationField.success({
        organizationId: id,
        data: formData.data,
      })
    );
    yield put(fetchOrganizationDataById.trigger({ organizationId: id }));
  } catch (err) {
    yield put(updateOrganizationField.failure({ error: err }));
  }
}

export function* fetchContactDataByAccountIdSaga({ payload }) {
  try {
    const { organizationId } = payload;
    const URL = `${envConfig.APIG_URL}core/organizations/${organizationId}/contacts?format=list`;
    const response = yield call(request, URL);
    yield put(fetchContactDataByOrganizationId.success(response));
  } catch (err) {
    yield put(fetchContactDataByOrganizationId.failure({ error: err }));
  } finally {
    yield put(fetchContactDataByOrganizationId.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(organizationFetchData.TRIGGER, fetchOrganizationsSaga),
    takeLatest(
      organizationFetchStatbarData.TRIGGER,
      organizationFetchStatbarDataSaga
    ),
    takeLatest(fetchOrganizationDataById.TRIGGER, fetchOrganizationByIdSaga),
    takeEvery(createOrganization.TRIGGER, createOrganizationSaga),
    takeEvery(editOrganization.TRIGGER, editOrganizationSaga),
    takeEvery(organizationArchive.TRIGGER, archiveOrganizationSaga),
    takeEvery(organizationRestore.TRIGGER, restoreOrganizationSaga),
    takeEvery(organizationChurn.TRIGGER, churnOrganizationSaga),
    takeEvery(updateOrganizationField.TRIGGER, updateOrganizationFieldSaga),
    takeLatest(
      fetchContactDataByOrganizationId.TRIGGER,
      fetchContactDataByAccountIdSaga
    ),
  ]);
}
